import TimeList from "@/components/Time/TimeList.vue";
import TimeEdit from "@/components/Time/TimeEdit.vue";
import AssignmentEdit from "@/components/Assignments/AssignmentEdit.vue";
import TimeFilter from "@/components/Time/TimeFilter.vue";
import TimeHeader from "@/components/Time/TimeHeader.vue";
import AssignmentHeader from "@/components/Assignments/AssignmentHeader.vue";
import AssignmentList from "@/components/Assignments/AssignmentList.vue";
import AssignmentDatatable from "@/components/Assignments/AssignmentDatatable.vue";
import AssignmentListPage from "@/components/Assignments/AssignmentListPage.vue";
import WorkHeader from "@/components/Work/WorkHeader.vue";
import WorkDatatable from "@/components/Work/WorkDatatable.vue";
import WorkListPage from "@/components/Work/WorkListPage.vue";
import WorkEdit from "@/components/Work/WorkEdit.vue";

export default [
    {
        path: 'time',
        name: 'All Time',
        redirect: "/time/list",
        components: {
            page: TimeList,
            header: TimeHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            // DON'T REALLY NEED A FILTER URL ...
            {
                path: "filter",
                name: "Time Filter",
                components: {
                    modal: TimeFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Time List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Time New",
                components: {
                    modal: TimeEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Time Edit",
                components: {
                    modal: TimeEdit,
                }
            },
        ]
    },
    {
        path: 'assignments',
        name: 'Assignments List',
        redirect: "/assignments/list",
        components: {
            page: AssignmentListPage,
        },
        meta: {
            requiresAuth: false,
            timeType: 'Assignments'
        },
        children: [
            {
                path: "list/:filter?",
                name: "Assignments List View",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Assignment New",
                components: {
                    modal: AssignmentEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Assignment Edit",
                components: {
                    modal: AssignmentEdit,
                }
            },
        ]
    },
    {
        path: 'work',
        name: 'All Work',
        redirect: "/work/list",
        components: {
            page: WorkListPage,
        },
        meta: {
            requiresAuth: false,
            timeType: 'Work'
        },
        children: [
            {
                path: "list/:filter?",
                name: "Work List View",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Work New",
                components: {
                    modal: WorkEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Work Edit",
                components: {
                    modal: WorkEdit,
                }
            },
        ]
    },
    {
        path: 'assignment',
        name: 'Assignment',
        redirect: "/assignments/list",
        components: {
            page: AssignmentListPage,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "new",
                name: "Assignment New Modal",
                components: {
                    modal: AssignmentEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Assignment Edit Modal",
                components: {
                    modal: AssignmentEdit,
                }
            },
        ]
    }
];